<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.pageHm.title', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row>
          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete
              :items="locoList"
              @change="refreshData"
              :label="$t('message.pageKm.loco', { value: 'default' })"
              item-value="loconum"
              item-text="loconum"
              multiple
              outlined
              dense
              v-model="payload.locomotives"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="payload.locomotives > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("message.select", { value: "default" }) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.loconum }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ payload.locomotives.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="$t('message.page.startDate', { value: 'default' })"
                  readonly
                  :value="startDateDisp"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDateVal"
                no-title
                @input="startDateMenu = false"
                @change="refreshData"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="$t('message.page.endDate', { value: 'default' })"
                  readonly
                  :value="endDateDisp"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDateVal"
                no-title
                @input="endDateMenu = false"
                @change="refreshData"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <div class="text-center" v-show="this.progress.chart">
          <v-progress-circular
            :size="50"
            color="#EEBB07"
            indeterminate
          ></v-progress-circular>
        </div>
        <apex-charts
          height="274"
          :options="chartOptions"
          :series="series"
          ref="chart"
        >
        </apex-charts>

        <div class="total">
          {{ $t("message.pageHm.total", { value: "default" }) }}
        </div>
        <div class="distance">{{ totalHm }} </div>
        <div class="total" style="font-size: 0.8em">
          {{ $t("message.pageKm.since", { value: "default" }) }}
          {{ sinceDate }}
        </div>
        <br />

        <v-row class="mb-5">
          <v-col>
            <v-card>
              <v-card-title class="portal-deep-blue-bg">
                {{ $t("message.pageHm.detailHm", { value: "default" }) }}
                <v-icon color="#fff" class="ml-auto"> mdi-train </v-icon>
              </v-card-title>
            </v-card>
            <v-data-table
              :headers="headersTable"
              :items="datasTable"
              class="elevation-1 km"
              hide-default-header
              :loading="progress.totalData"
              :loading-text="$t('message.loadingText', { value: 'default' })"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th
                      style="cursor: pointer"
                      v-for="item in headers"
                      :key="item.value"
                    >
                      {{ item.text }}
                      <v-icon color="#9FAAAF" style="float: right"
                        >mdi-swap-vertical</v-icon
                      >
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:[`item.locomotive`]="{ item }">
                <b>{{ item.locomotive }} </b>
              </template>
              <template v-slot:[`item.distance`]="{ item }">
                {{ formatEnginehours(item.enginehours) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>


      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import ApexCharts from "vue-apexcharts";
import { mapActions, mapGetters } from "vuex";
import {
  firstDateOfCurrentMonth,
  currentDate,
  parseDate,
  parseEndDate,
  formatDate,
  numStr,
  formatSinceDate,
} from "@/shared/DateHelper";
import CascService from "@/services/CascService";

export default {
  title: "Engine hours",
  watch: {
    getterCurrentClient: function () {
      this.initializeDates();
      this.initalizePayload();
      this.refreshData();
    },

    "$i18n.locale": function () {
      this.displaySinceDate();
    },
  },
  methods: {
    ...mapActions("customer", {
      actionGetLocos: "loadLocos",
    }),

    displaySinceDate() {
      this.sinceDate = formatSinceDate(
        this.payload.startdate,
        this.$i18n.locale
      );
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllLoc) {
          this.payload.locomotives = [];
        } else {
          this.payload.locomotives = this.extractLoco(this.locoList);
          this.refreshData();
        }
      });
    },

    formatEnginehours(value) {
      return numStr(value);
    },


    async loadLocos() {
      let payload = {
        customer: this.getterCurrentClient,
        start: firstDateOfCurrentMonth(),
        end: currentDate(),
      };
      await this.actionGetLocos(payload);
      this.getChartHmDatas();
      this.getTotalHm();
      this.getTotalHmByLoco();
    },

    async refreshData() {
      this.payload.enddate = parseEndDate(this.endDateVal);
      this.payload.startdate = parseDate(this.startDateVal);
      this.loadLocos();
    },

    getTotalHm() {
      this.displaySinceDate();
      CascService.findTotalHmByCustomer(this.payload).then((response) => {
        if (response.data.length == 0) {
          this.totalHm = 0;
        } else {
          this.totalHm = numStr(response.data);
        }
      });
    },

    getTotalHmByLoco() {
      this.progress.totalData = true;
      CascService.findTotalHmLocosByCustomer(this.payload)
        .then((response) => {
         this.datasTable = this.getHmDatas(response.data);
          this.progress.totalData = false;
        })
        .catch((err) => {
          console.log("getTotalHmByLoco:", err);
          this.progress.totalData = false;
        });
    },

    getHmDatas(data) {
      let list = [];
      var i;
      for (i = 0; i < this.getterLocos.length; i++) {
        let find = data.find(
          (e) => e.locomotive == this.getterLocos[i].loconum
        );
        if (find !== undefined) {
          list.push({
            locomotive: this.getterLocos[i].loconum,
            enginehours: find === undefined ? "" : find.enginehours,
          });
        }
      }
      return list;
    },


    getChartHmDatas() {
      this.progress.chart = true;
      CascService.findTotalHmLocosByCustomerAndDays(this.payload)
        .then((response) => {
          let retour = response.data;
          var i;
          var data = [];

          this.chartOptions.xaxis.categories.splice(
            0,
            this.chartOptions.xaxis.categories.length
          );
          
          for (i = 0; i < retour.length; i++) {
            data.push(retour[i].enginehours);
            this.chartOptions.xaxis.categories.push(retour[i].day);
          }

          this.$refs.chart.updateSeries([
            {
              name: "Engine hours",
              data: data,
            },
          ]);
          this.progress.chart = false;
        })
        .catch((error) => {
          console.log("getChartHmDatas: ", error);
          this.progress.chart = false;
        });
    },

    
    initializeDates() {
      this.startDateVal = formatDate(firstDateOfCurrentMonth());
      this.endDateVal = formatDate(currentDate());
    },

    initalizePayload() {
      this.payload.startdate = firstDateOfCurrentMonth();
      this.payload.enddate = currentDate();
      this.payload.clients = [this.getterCurrentClient];
      this.payload.locomotives = [];
    },

  },

  name: "HmPage",
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
    }),

    ...mapGetters("customer", {
      getterLocos: "getFilterLoc",
    }),
    selectAllLoc() {
      if (this.payload.locomotives == null) return false;
      return this.locoList.length === this.payload.locomotives.length;
    },

    selectSomeLoc() {
      if (this.payload.locomotives == null) return false;
      return this.payload.locomotives.length > 0 && !this.selectAllLoc;
    },

    icon() {
      if (this.selectAllLoc) return "mdi-close-box";
      if (this.selectSomeLoc) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    headersTable() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "locomotive",
          sortable: true,
        },
        {
          text: this.$t("message.pageHm.cumulativeHm", { value: "default" }),
          value: "enginehours",
          sortable: true,
        },
      ];
    },

    endDateDisp() {
      return this.endDateVal;
    },

    startDateDisp() {
      return this.startDateVal;
    },
  },
  mounted() {
    this.initializeDates();
    this.initalizePayload();
    this.loadLocos();
    this.items = this.getterLocos;
    this.locoList = this.getterLocos;
  },
  data: () => ({
    isDesc: false,
    payload: {
      startdate: null,
      enddate: null,
      clients: null,
      locomotives: null,
    },
    progress: {
      chart: true,
      avgData: true,
      totalData: true,
    },
    vstatus: [],
    totalHm: 0,
    items: [],
    locoList: [],
    sinceDate: "",
    datasTable: [],
    locos: [],
    endDateVal: null,
    endDateMenu: false,
    startDateVal: null,
    startDateMenu: false,
    series: [
      {
        name: "",
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        type: "bar",
        stacked: true,
        height: 350,
        redrawOnParentResize: true,
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 0,
      },
      colors: ["#EEBB07", "#6dbea7", "#003441", "#CCD2D5"],
      xaxis: {
        type: "date",
        categories: [],
        tickPlacement: "between",
        labels: {
          formatter: function (value) {
            if (value.length == 10) {
              const [month, day] = value.substr(5, 5).split("-");
              return `${day}-${month}`;
            }
          },
        },
      },
      tooltip: {
        x: {
          format: "dd-MM-yy",
        },
      },
    },
  }),
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    ApexCharts,
  },
};
</script>

<style scoped>
.portal-green-bg {
  height: 59px;
  color: #fff;
}

thead {
  background-color: #fafafa;
  color: #9faaaf;
}

tbody {
  color: #00475a;
  font-weight: bolder;
}

.portal-deep-blue-bg {
  height: 59px;
  color: #fff;
  text-transform: uppercase;
}

.v-card__text {
  padding: 0px;
}

.total {
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}

.distance {
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  color: #eebb07;
  font-size: 2.5em;
}

.km {
  color: #00475a !important;
}
</style>
